import { render } from "./BottomSlideSheet.vue?vue&type=template&id=6cb716a8&scoped=true"
import script from "./BottomSlideSheet.vue?vue&type=script&lang=js"
export * from "./BottomSlideSheet.vue?vue&type=script&lang=js"

import "./BottomSlideSheet.vue?vue&type=style&index=0&id=6cb716a8&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20250805.141732/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb716a8"]])

export default __exports__